import React from "react";
import { Link } from "react-router-dom";
import { restaurantInfo } from "../data/mock";
import { Instagram, Facebook, Music2, ExternalLink, Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#ECE8E1] border-t border-[var(--mm-line)] pt-20 pb-10">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="/media/logo-300.png"
              alt="Mamamina's Soulfeed"
              className="h-20 w-auto object-contain mb-4"
            />
            <p className="text-[var(--mm-cream-muted)] max-w-sm font-light leading-relaxed">
              West African soul food, cooked slow and served generous. From our family to yours, in the heart of Acacia Ridge, Brisbane.
            </p>

            {/* Order links */}
            <div className="mt-8">
              <div className="section-label mb-4">Order Online</div>
              <div className="flex flex-wrap gap-x-5 gap-y-2">
                {restaurantInfo.delivery.map((s) => (
                  <a
                    key={s.name}
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-1.5 text-sm text-[var(--mm-cream)] hover:text-[var(--mm-accent)] transition-colors"
                  >
                    {s.name}
                    <ExternalLink size={12} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Visit */}
          <div>
            <div className="section-label mb-5">Visit</div>
            <p className="text-[var(--mm-cream)] text-sm leading-relaxed">
              {restaurantInfo.address.line1}<br />
              {restaurantInfo.address.line2}
            </p>
            <a href={`tel:${restaurantInfo.contact.phone}`} className="link-underline mt-4 inline-block text-[var(--mm-accent)] text-sm" data-testid="footer-phone">{restaurantInfo.contact.phoneDisplay}</a>
            <a href={`tel:${restaurantInfo.contact.mobile}`} className="link-underline mt-1 block text-[var(--mm-cream-muted)] hover:text-[var(--mm-accent)] transition-colors text-xs" data-testid="footer-mobile">{restaurantInfo.contact.mobileDisplay}</a>
            <a
              href={restaurantInfo.social.google}
              target="_blank"
              rel="noreferrer"
              className="link-underline mt-3 block text-[var(--mm-cream-muted)] hover:text-[var(--mm-accent)] transition-colors text-sm"
            >
              Find us on Google
            </a>
          </div>

          {/* Follow */}
          <div>
            <div className="section-label mb-5">Follow</div>
            <div className="flex flex-col gap-3">
              <a href={restaurantInfo.social.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-[var(--mm-cream)] hover:text-[var(--mm-accent)] transition-colors">
                <Instagram size={16} /> @mamaminassoulfeed_
              </a>
              <a href={restaurantInfo.social.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-[var(--mm-cream)] hover:text-[var(--mm-accent)] transition-colors">
                <Facebook size={16} /> MamaMinas Soulfeed
              </a>
              <a href={restaurantInfo.social.tiktok} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-[var(--mm-cream)] hover:text-[var(--mm-accent)] transition-colors">
                <Music2 size={16} /> TikTok
              </a>
              <a href={`mailto:${restaurantInfo.contact.email}`} className="text-[var(--mm-cream-muted)] hover:text-[var(--mm-accent)] transition-colors mt-2 text-sm">
                {restaurantInfo.contact.email}
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[var(--mm-line)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs tracking-[0.2em] uppercase text-[var(--mm-cream-muted)]">
            © {new Date().getFullYear()} Mamamina's Soulfeed. Made with love in Brisbane.
          </p>
          <div className="flex gap-6 text-xs tracking-[0.2em] uppercase text-[var(--mm-cream-muted)]">
            <a href="#" className="hover:text-[var(--mm-accent)] transition">Privacy</a>
            <a href="#" className="hover:text-[var(--mm-accent)] transition">Terms</a>
            <a href="#" className="hover:text-[var(--mm-accent)] transition">Accessibility</a>
            <Link
              to="/admin"
              data-testid="footer-owner-admin"
              className="inline-flex items-center gap-1.5 hover:text-[var(--mm-accent)] transition"
              title="Owner dashboard — orders, menu, reservations"
            >
              <Lock size={11} /> Owner Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
